// extracted by mini-css-extract-plugin
module.exports = {"block":"block_block__odDGR","title":"block_title__5zn7H","titleBlue":"block_titleBlue__XXYbq block_title__5zn7H","titleSelected":"block_titleSelected__1Gcmu"};